import { PrimeReactModal } from "@finanedi.es/storybook"
import { MODAL_STYLES } from "constants/primereactStyles"
import React from "react"
import { useTranslation } from "react-i18next"
import FormInvitarEmpresasGestionadas from "./FormInvitarEmpresasGestionadas/FormInvitarEmpresasGestionadas"

interface ModalInvitarEmpresaGestionadaProps {
  visible?: boolean
  onHide: () => void
}

const ModalInvitarEmpresaGestionada: React.FC<
  ModalInvitarEmpresaGestionadaProps
> = ({ visible = true, onHide }) => {
  const { t } = useTranslation()

  return (
    <PrimeReactModal
      visible={visible}
      className='tw-w-192 tw-rounded-lg tw-py-6 tw-px-6 tw-bg-white'
      baseZIndex={20}
      ptContext={MODAL_STYLES}
      closable={false}
      keepInViewport={false}
      header={
        <div className='tw-w-full tw-h-10 tw-text-2xl tw-font-medium tw-flex tw-items-center'>
          {t("empresasGestionadas.modal.title")}
        </div>
      }
    >
      <FormInvitarEmpresasGestionadas
        onHide={onHide}
        t={t}
      />
    </PrimeReactModal>
  )
}

export default ModalInvitarEmpresaGestionada
